import {notification} from 'antd';

const NotificationService = {
  success(message, description, duration = 5) {
    notification.success({
      message,
      description,
      duration,
      placement: 'top',
    });
  },

  error(message, description, duration = 5) {
    notification.error({
      message,
      description,
      duration,
      placement: 'top',
    });
  },

  info(message, description, duration = 5) {
    notification.info({
      message,
      description,
      duration,
      placement: 'top',
    });
  },

  warning(message, description, duration = 5) {
    notification.warning({
      message,
      description,
      duration,
      placement: 'top',
    });
  },
};

export default NotificationService;
